import { useEffect, useState } from "react";
import "./CategoryNav.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { ChevronDown, Search } from "lucide-react";
import ApiService from "../../components/Api_services";
import { useLocation, useSearchParams } from "react-router-dom";
import FallbackImg from "../FallbackImg";

const Category = ({
  productGroupList = [],
  clearInput,
  setClearInput,
  disabled,
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchParams, setSearchParams] = useSearchParams();

  const [openIndex, setOpenIndex] = useState(null);
  const [animationState, setAnimationState] = useState("");
  const [selectedProductGroup, setSelectedProductGroup] = useState("");

  // Initialize selected product group from URL parameters
  useEffect(() => {
    const productFromUrl = searchParams.get("product");
    setSelectedProductGroup(productFromUrl || "");
  }, [searchParams]);

  const handleToggle = (index) => {
    if (disabled) return;

    if (openIndex === index) {
      // Closing
      setAnimationState("closing");
      setTimeout(() => {
        setOpenIndex(null);
        setAnimationState("");
      }, 300); // Match CSS transition duration
    } else {
      // Opening
      setOpenIndex(index);
      setAnimationState("opening");
      setTimeout(() => {
        setAnimationState("");
      }, 300);
    }
  };

  //product list
  const [searchProduct, setSearchProduct] = useState("");

  const filteredProductGroups = productGroupList.filter((group) =>
    (group.category_name || group.name || "")
      .toLowerCase()
      .includes(searchProduct.toLowerCase()),
  );

  const handleProductGroupChange = (productCode, productName) => {
    const newSelected = selectedProductGroup === productCode ? "" : productCode;
    setSelectedProductGroup(newSelected);

    // Update URL parameters
    const newSearchParams = new URLSearchParams(searchParams);
    if (newSelected) {
      newSearchParams.set("product", newSelected);
      newSearchParams.set("search", "1");
      // 移除 filter_type 参数
      //newSearchParams.delete("filter_type");
    } else {
      newSearchParams.delete("product");
      newSearchParams.delete("attributes");
      // 移除 filter_type 参数
      //newSearchParams.delete("filter_type");
    }
    setSearchParams(newSearchParams);

    // Removed auto-collapse behavior - dropdown stays open after selection
  };

  const handleClearProduct = () => {
    setSelectedProductGroup("");

    // Update URL parameters
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete("product");
    newSearchParams.delete("attributes");
    setSearchParams(newSearchParams);

    // Removed auto-collapse behavior - dropdown stays open after clearing
  };

  // Clear search input if clearInput is true or auto-open dropdown
  useEffect(() => {
    if (clearInput === "openDropdowns") {
      if (!disabled) {
        // Auto-open product dropdown
        setOpenIndex(0);
        setAnimationState("opening");
        setTimeout(() => {
          setAnimationState("");
        }, 300);
      }
      // Reset the clearInput flag after both components have processed it
      if (typeof setClearInput === "function") setClearInput(false);
    } else if (clearInput) {
      setSearchProduct("");
      if (typeof setClearInput === "function") setClearInput(false);
    }
  }, [clearInput, setClearInput]);

  // force-closes the dropdown whenever disabled becomes true
  useEffect(() => {
    if (disabled && openIndex !== null) {
      setAnimationState("closing");
      setTimeout(() => {
        setOpenIndex(null);
        setAnimationState("");
      }, 300);
    }
  }, [disabled]);

  return (
    <div className="categorynav_v2">
      <div className="categorynav-content_v2">
        <div className="categorynav-dropdown_v2">
          <div className="categoryitem-container_v2">
            <div
              className={`categoryitem_v2 ${disabled ? " disabled" : ""}`}
              onClick={() => handleToggle(0)}
            >
              <strong>PRODUCT</strong>
              <ChevronDown
                size={16}
                className={openIndex === 0 ? "rotate" : ""}
              />
            </div>

            {openIndex === 0 && (
              <div className={`product-dropdown-wrapper_v2 ${animationState}`}>
                <div className="searchbar2-container_v2">
                  <div className="searchbar2_v2">
                    <input
                      type="text"
                      placeholder="Search products..."
                      value={searchProduct}
                      onChange={(e) => setSearchProduct(e.target.value)}
                    />
                    <Search size={16} />
                  </div>
                </div>

                <ul className="subcategorylist_v2">
                  {filteredProductGroups.map((group, index) => (
                    <li key={index} className="subcategoryitem_v2">
                      <input
                        type="radio"
                        id={`productGroup-${group.category_code}`}
                        name="productGroup"
                        value={group.category_code}
                        checked={selectedProductGroup === group.category_code}
                        onChange={() =>
                          handleProductGroupChange(
                            group.category_code,
                            group.category_name,
                          )
                        }
                      />
                      <label
                        htmlFor={`productGroup-${group.category_code}`}
                        style={{ cursor: "pointer" }}
                      >
                        {group.category_name}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;
